import React from "react";
import KickImage from 'Reuseables/KickImage';

/* UTILS */
/* UTILS / HELPERS */
import { getCloudImageUrl } from "../../../../../utils"

interface kredivoInstallment {
  label: string
  monthly_installment: number
  value: string
}

interface paymentMethod {
  type?: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

type SplitPaymentMethodCardProps = {
  selectedSplitPaymentMethod: paymentMethod | null
  setSelectedSplitPaymentMethod: (args: paymentMethod | kredivoInstallment | null) => void
}

const SplitPaymentMethodCard: React.FC<SplitPaymentMethodCardProps> = ({
  selectedSplitPaymentMethod,
  setSelectedSplitPaymentMethod
}): JSX.Element => {
  return (
    <div className={`split-payment-methods-card ${selectedSplitPaymentMethod ? selectedSplitPaymentMethod.logo ? "" : "no-img" : ""}`}>
      {selectedSplitPaymentMethod && selectedSplitPaymentMethod.logo && <KickImage
        src={getCloudImageUrl(selectedSplitPaymentMethod.logo)}
        alt="..."
      />}
      <p>{selectedSplitPaymentMethod && selectedSplitPaymentMethod.label}</p>
      <div
        onClick={() => {
          setSelectedSplitPaymentMethod(null);
        }}
        className="button-cancel"
      >
        <p>Cancel</p>
      </div>
    </div>
  )
}

export default SplitPaymentMethodCard